<template>
  <div v-if="programmeStore.currentProgrammeId" id="programme-otj-page" class="content-with-spacing">
    <div class="heading-container header-margin">
      <h1 v-if="programmeStore.currentProgramme">
        <i class="fas fa-clock"></i> O.T.J. Logs - <b>{{ programmeStore.currentProgramme.name }}</b>
      </h1>
      <div v-if="programmeStore.userProgrammes.length > 1" class="programme-dropdown">
        <span>Select Programme:</span>
        <k-dropdown :options="programmeStore.userProgrammes" v-model="currentProgrammeId"></k-dropdown>
      </div>
    </div>
    <k-nav-tabs :tabs="tabs" :current-tab="currentTab"/>
    <router-view></router-view>
  </div>
</template>

<style scoped>
.heading-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}

.heading-container h1 {
  padding: 15px 0;
}

.programme-dropdown {
  display: flex;
  align-items: center;
}

.programme-dropdown span {
  margin-right: 1em;
}
</style>

<script>
import { storeToRefs } from 'pinia';
import KNavTabs from '@base-components/k-nav-tabs.vue';
import KDropdown from '@base-components/k-dropdown.vue';
import useAppProgrammeStore from '@stores/app-programme-store';

export default {
  components: {
    KNavTabs,
    KDropdown,
  },

  mounted() {
    if (!this.programmeStore.isProgrammeAccessible(this.$route.params.programmeId)) {
      this.$router.push({
        name: '404',
      });
    }
  },

  data() {
    const programmeStore = useAppProgrammeStore();
    const { currentProgrammeId } = storeToRefs(programmeStore);
    return {
      currentProgrammeId,
      programmeStore,
      tabs: [
        {
          name: 'Logs',
          routeName: 'programme_otj_logs',
          routeParams: {
            programmeId: this.$route.params.programmeId,
          },
        },
        {
          name: 'Guidance',
          routeName: 'programme_otj_guidance',
          routeParams: {
            programmeId: this.$route.params.programmeId,
          },
        },
      ],
    };
  },

  watch: {
    currentProgrammeId(newVal) {
      if (this.programmeStore.isProgrammeAccessible(newVal)) {
        this.$router.push({
          name: 'programme_otj_logs',
          params: { programmeId: newVal },
        });
      } else {
        this.$logger.info('Programme not accessible, routing to 404', { programmeId: newVal });
        this.$router.push({
          name: '404',
        });
      }
    },
  },

  computed: {
    currentTab() {
      return this.$route.name;
    },
  },
};
</script>
